import { IAdsToEmbed, IArtSponsParams, ServiceSlotType, TargetingType } from '../ad-services.types';
import { IADOCEANService, IAOServiceSlot, IServiceADOCEANUtils } from './service-adocean.types';
import { isDefined } from '../../../helpers/js-utils';
import DebugUANC from '../../../core/version/debug';
import {
    getArtSponsParamsFromService,
    getPlacementNamesToDestroy,
    groupExecution,
    setArtSponsParamsFromService,
} from '../ad-services.utils';
import { AD_SERVERS } from '../../../configs/constants';
import { setADOMaster } from './embedding-adocean.utils';

/* eslint-disable @typescript-eslint/no-unused-vars */
const insertAd = (slotConfig: ServiceSlotType) => {
    // const slot = slotConfig as IAOServiceSlot;
};
const insertAds = (adsToEmbed: IAdsToEmbed): void => {
    const service = window.Inpl.Ad.services?.ADOCEANService as IADOCEANService;

    const slotNames = Object.keys(adsToEmbed);
    const slotConfigs = service.slots.filter((slotConfig) => slotNames.includes(slotConfig.name));

    slotConfigs.length && setADOMaster(slotConfigs);
};
const lazyLoadInsertAd = (slotConfig: ServiceSlotType, placementIdsToInsert: string[], targeting: TargetingType | null = null) => {
    const { UANC } = window.Inpl.Ad || {};

    UANC instanceof DebugUANC && UANC.table(`ADOCEAN [lazyLoadInsertAd] name: ${slotConfig.name}}`, slotConfig);

    groupExecution(slotConfig, placementIdsToInsert, targeting);
};

/**
 * Odświeżenie wszystkich jednostek reklamowych.
 * AO nie ma możliwości odświeżenia pojedynczego slotu. Aktualizuje cały kod master w związku z czym odświeżone zostaną wszystkie reklamy AO.
 * Nie ogranicza się do reklam znajdujących się w viewport - aktualizuje cały kod master w związku z czym przeładuje wszystkie reklamy.
 *
 * @returns {void}
 */
const refreshAds = (): void => {
    // todo - chwilowo wstrzymany refresh dla AO
    // const { services } = window.Inpl.Ad;
    // const { adUnits, slots } = services?.ADOCEANService as IADOCEANService;
    //
    // // wyrenderowane sloty
    // const renderedSlotNames = Object.values(adUnits).map((adUnit: IADOCEANadUnit) => adUnit.name);
    //
    // const slotConfigs = renderedSlotNames.reduce((configs: IAOServiceSlot[], slotName) => {
    //     const slotConfig = (slots as IAOServiceSlot[]).find((slot) => slot.name === slotName);
    //     if (slotConfig) return [...configs, slotConfig];
    //     return configs;
    // }, []);
    //
    // setADOMaster(slotConfigs);
};

/**
 * Usuwa jednostkę reklamową - przekazanie slotu do ado.stopSlave, usuwa obiekt definicji w adUnits oraz informację z renderedPlacements.
 *
 * @param {ServiceSlotType} slotConfig - slot serwisowy do osadzenia
 * @param {string | null} placementIdToDestroy - opcjonalnie, nazwa id kontenera, który ma zostać usunięty
 * @returns {void}
 */
const destroyAd = (slotConfig: ServiceSlotType, placementIdToDestroy: string | null): void => {
    const { services, UANC } = window.Inpl.Ad;
    const { adUnits, master } = services?.ADOCEANService as IADOCEANService;

    const slotToDestroy = slotConfig as IAOServiceSlot;
    const placementsToCheck: string[] = placementIdToDestroy ? [placementIdToDestroy] : slotToDestroy.placementIds;
    const placementsToDestroy = getPlacementNamesToDestroy(slotToDestroy, placementsToCheck);

    if (!placementsToDestroy.length) {
        UANC instanceof DebugUANC && UANC.warn(`[destroyAd] No placements to destroy for slot ${slotConfig.name}.`);
        return;
    }
    if (adUnits[slotToDestroy.slotid]) {
        window.ado.stopSlave(slotToDestroy.slotid, master);
        placementsToDestroy.forEach((placementName: string) => {
            delete adUnits[slotToDestroy.slotid];
            delete slotToDestroy.renderedPlacements?.[placementName];
            UANC instanceof DebugUANC && UANC.success(`[destroyAd] Placement ${placementName} destroyed successfully.`);
        });
    } else {
        UANC instanceof DebugUANC && UANC.warn(`[destroyAd] No adUnit to destroy for slot ${slotConfig.name}.`);
    }
};

const hbht = (prf: string, id: string, arg: string, sarg: string, fastid: string): void => {
    const { ADOCEANService } = window.Inpl.Ad.services || {};
    if (!ADOCEANService) return;

    const { adUnits, emptyData } = ADOCEANService;
    const { hbParams } = emptyData;
    let args = `id=${id}&stparam=${arg}&sarg=${sarg}`;

    if (emptyData.hbTmpFunctionName === '') {
        emptyData.hbTmpFunctionName = id;
        adUnits[emptyData.hbTmpFunctionName] = { name: emptyData.hbTmpFunctionName, isOnSite: false };
    }

    emptyData.hbType = prf;

    if (isDefined(fastid)) {
        args += `&fastid=${fastid}`;
    }

    hbParams.push({ name: emptyData.hbTmpFunctionName, args });
    emptyData.hbTmpFunctionName = '';
};

/**
 *  Zapisuje do serwisu ADOCEAN konfigurację reklamy dla artykułu sponsorowanego / linku sponsorowanego.
 *
 * @param {string} name - nazwa - linkSpons
 * @param {IArtSponsParams | null} data - konfiguracja
 * @returns {void}
 */
export const setArtSponsParams = (name: string, data: IArtSponsParams | null): void =>
    setArtSponsParamsFromService(`${AD_SERVERS.ADOCEAN}Service`, name, data, false);

/**
 *  Przekazanie konfiguracji o reklamie dla wskazanego linkSpons.
 *
 * @param {string} name - nazwa - linkSpons
 * @param {(data: IArtSponsParams | null) => void | null} cb - opcjonalnie, cb do wywołania dla linkSpons
 * @returns {IArtSponsParams | null} informacja o reklamie
 */
const getArtSponsParams = (name: string, cb: ((data: IArtSponsParams | null) => void) | null = null): IArtSponsParams | null =>
    getArtSponsParamsFromService(`${AD_SERVERS.ADOCEAN}Service`, name, cb);

export const serviceADOCEANUtils: IServiceADOCEANUtils = {
    insertAd,
    insertAds,
    lazyLoadInsertAd,
    refreshAds,
    destroyAd,
    hbht,
    setArtSponsParams,
    getArtSponsParams,
};
